import React from "react";
import logger from "logger";

import AccountDetailsSection from "TaskHistory/Tasklet/SubTasklets/AccountDetailsSection.js";
import StatusSection from "TaskHistory/Tasklet/SubTasklets/StatusSection.js";
import ErrorLogsSection from "TaskHistory/Tasklet/SubTasklets/ErrorLogsSection.js";
import ActionsSection from "TaskHistory/Tasklet/SubTasklets/ActionsSection.js";
import TaskletCard from "./TaskletCard";
import CardContent from "@material-ui/core/CardContent";
import { StringValue } from "./StringValue";
import { StringArray } from "./StringArray";
import { WonItemsWithDialog } from "./WonItemsWithDialog";

export default function(props) {
  const { task } = props;

  return (
    <TaskletCard title="Claim Rewards">
      <CardContent>
        <AccountDetailsSection
          task={task}
          showOwner={props.showOwner}
          showUser={props.showUser}
        />
        <StatusSection task={task} />
        <StringArray
          label={"Events already done/in process"}
          array={task.taskstatusdetail.eventsClaimed}
        />
        <StringValue
          label={"Currently Claiming"}
          value={task.taskstatusdetail.currentData}
          valueParser={(v) =>
            `${task.taskstatusdetail.currentData.eventname}: Pending Claims(
              ${task.taskstatusdetail.currentData.claimspending})`
          }
        />
        <WonItemsWithDialog
          label={"Won Items"}
          countlabel={"Total Item Types"}
          value={task.taskstatusdetail.itemswon}
        />
        <ErrorLogsSection task={task} />
      </CardContent>
      <ActionsSection task={task} />
    </TaskletCard>
  );
}
